const STOP_WORDS = new Set(["and", "of", "the", "a", "an", "in", "on", "for", "to"]);

export function titleFilterKey(value) {
  return String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .replace(/\s+/g, " ");
}

function stem(word) {
  if (word.length > 4 && word.endsWith("s") && !/(ss|ous|is|us)$/.test(word)) {
    return word.slice(0, -1);
  }
  return word;
}

function tokens(key) {
  return key
    .split(" ")
    .filter((word) => word && !STOP_WORDS.has(word))
    .map(stem);
}

export function titleKeysMatch(a, b) {
  if (!a || !b) return false;
  if (a === b) return true;
  const left = tokens(a);
  const right = tokens(b);
  if (!left.length || !right.length) return false;
  const [shorter, longer] = left.length <= right.length ? [left, right] : [right, left];
  if (shorter.length < 2 && longer.length !== shorter.length) return false;
  const longerSet = new Set(longer);
  return shorter.every((word) => longerSet.has(word));
}

export function findTitleFilterKey(existing, key) {
  for (const item of existing) {
    if (titleKeysMatch(item, key)) return item;
  }
  return null;
}
